import { usePrompt } from '@studio/design-system/prompt';

export const useConfirmMakeModel = () => {
  const prompt = usePrompt();

  return ({ onOkay, onCancel }: { onOkay?: () => void; onCancel?: () => void }) => {
    prompt.confirm({
      title: 'Enter Make & Model',
      message:
        'We recommend you add the make and model of your camera in order to use the full studio functionality. Adding your device information allows us to load a driver with unique image setting commands and movement calibrations.',
      onConfirm(answer) {
        if (answer) {
          onCancel?.();
        } else {
          onOkay?.();
        }
      },
      cancel: { label: 'Skip' },
      okay: { label: 'Enter Make & Model' }
    });
  };
};
